

import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Action, Mutation, State } from "vuex-class"

import TenantInfo from "@/types/tenantInfo"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"

import tenantApi from "@/services/api_Tenant"
import api from "@/services/api"
import { BaseState } from "@/store"
import { CurrentUser } from "@/types/user"
import DiagnosticInfo from "@/types/DiagnosticInfo"

@Component({
	components: {
		"scrollbar": VuePerfectScrollbar
	}
})
export default class DiagnosticInformation extends Vue {
	@State((state: BaseState) => state.me) public me!: CurrentUser;

	@State((state: BaseState) => state.uiVersion) public uiVersion!: string | null;

	loaded = false
	diagnosticInfo: DiagnosticInfo | null = null

	async mounted () {
		this.diagnosticInfo = await api.sessionInfo()
		this.loaded = true
	}
}

